import * as R from 'ramda'
import URI from 'urijs'
import { makeCancellable, takeLatest } from 'vuex-cancellable-actions'

import { collectToLookup } from '../../helpers'
import { apiGet } from '../api'

export default {
  namespaced: true,
  state: {
    MAX_RECORDS: 100, // max number of records per request
    LOAD_MORE_RECORDS: 50,
    map: null, // {'1': { 'id': 1, ... }, '2': { ... } }
    serverOrder: null, // [1, 2]
    total: null, // Общее кол-во постов на сервере
    loading: false, // загрузка списка постов
  },
  getters: {
    posts: (state) => state.serverOrder && state.map && state.serverOrder
      .map(postId => state.map[postId]),
    post: (state) => postId => state.map && (state.map[postId] || null),
  },
  mutations: {
    setLoading: (state, { value }) => { state.loading = !!value },
    setList: (state, { posts, total }) => {
      state.map = posts ? collectToLookup('id', posts) : null
      state.serverOrder = posts ? posts.map(post => post.id) : null
      state.total = total || null
    },
    addToList: (state, { posts, total }) => {
      state.map = {
        ...state.map,
        ...collectToLookup('id', posts),
      }
      state.serverOrder = R.uniq([
        ...state.serverOrder,
        ...posts.map(post => post.id),
      ])
      state.total = total
    },
  },
  actions: makeCancellable({
    getList: takeLatest((
      { state, rootState, commit, dispatch },
      { limit = null, offset = null } = {},
    ) => {
      if (!rootState.auth.token) {
        return Promise.reject(new Error('requires auth'))
      }

      const query = {}
      if (limit !== null) query.limit = limit
      if (offset !== null) query.offset = offset
      const url = URI('/api/post/list/').addQuery(query).toString()

      commit('setLoading', { value: true })
      return apiGet({ url, rootState, dispatch })
        .then(({ res: posts, total }) =>
          offset
            ? commit('addToList', { posts, total })
            : commit('setList', { posts, total }))
        .finally(() => commit('setLoading', { value: false }))
    }),
  }),
}
